<template>
  <v-row dense>
    <v-col
      cols="6"
      class="font-weight-bold text-subtitle-6 py"
    >
      {{ label }}
    </v-col>
    <v-col
      cols="6"
    >
      {{ value }}
      <slot name="append" />
    </v-col>
  </v-row>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'AttributeDisplay',
  props: {
    label: { type: String, required: true },
    value: { type: [String, Number], required: true },
    colsLabel: { type: [String, Number], default: 4 }, // control width of label
    colsValue: { type: [String, Number], default: 8 }, // control width of value
  },
})
</script>

<style scoped>

</style>
